<form [formGroup]="form">

  <app-input-group>
    <label appLabel>{{ 'quadrantMappingModal.validFrom' | translate }}</label>
    <input appInputDate [defaultDate]="false" formControlName="validFrom">
  </app-input-group>

  <div class="py-2 text-sm font-semibold">
    {{ 'quadrantMappingModal.mappings' | translate }}
  </div>

  <app-input-group>
    <label appLabel>A14</label>
    <select appSelect formControlName="mappingA14">
      @for (item of activeQuadrantList; track item.value) {
        <option [value]="item.key">{{ item.value | translate }}</option>
      }
    </select>
  </app-input-group>

  <app-input-group>
    <label appLabel>A23</label>
    <select appSelect formControlName="mappingA23">
      @for (item of activeQuadrantList; track item.value) {
        <option [value]="item.key">{{ item.value | translate }}</option>
      }
    </select>
  </app-input-group>

  <app-input-group>
    <label appLabel>R12</label>
    <select appSelect formControlName="mappingR12">
      @for (item of reactiveQuadrantList; track item.value) {
        <option [value]="item.key">{{ item.value | translate }}</option>
      }
    </select>
  </app-input-group>

  <app-input-group>
    <label appLabel>R34</label>
    <select appSelect formControlName="mappingR34">
      @for (item of reactiveQuadrantList; track item.value) {
        <option [value]="item.key">{{ item.value | translate }}</option>
      }
    </select>
  </app-input-group>

  <div class="pt-4 flex items-center gap-2">
    <app-toggle formControlName="resendTimeSeries"></app-toggle>
    <span class="text-sm">{{ 'quadrantMappingModal.resendTimeSeries' | translate }}</span>
  </div>

  @if (form.value.resendTimeSeries) {
    <div class="pt-2 text-xs text-gray-500 italic">
      {{ 'quadrantMappingModal.resendValidToHint' | translate }}
    </div>
    <app-input-group>
      <label appLabel>{{ 'quadrantMappingModal.resendValidTo' | translate }}</label>
      <input appInputDate [defaultDate]="false" formControlName="resendValidTo">
    </app-input-group>
  }

</form>
